import TableRegion from "./TableRegion";

class NullTableRegion extends TableRegion{
    constructor(){
        super(0, 0, 0, 0);
    }

    containsCell(cell) { return false; }
    containsCol(col) { return false; }
    containsRow(row) { return false; }
    contains(row, col) { return false; }
    union(otherRegion) { return otherRegion; }
    toString() { return "[Null Region]" }
    isLeftmostCell(cell) { return false; }
    isUpwardmostCell(cell) { return false; }
    isRightmostCell(cell) { return false; }
    isDownwardmostCell(cell) { return false; }
}

export default new NullTableRegion();


// WEBPACK FOOTER //
// ./web/js/table/NullTableRegion.js